import { Button } from "@/components/button";
import { FONT } from "@/styles/common";
import { Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomButton = styled(Button)`
    width: 84px;
    ${FONT("cormorant", 14, 700)}
`;

export const CustomText = styled(Text)`
    flex-shrink: 0;
    ${FONT("notoSerif", 24, 500)}

    @media (max-width:${({ theme }) => theme.MEDIA.mobile}) {
        ${FONT("notoSerif", 16, 500)}
    }
`;
